export enum LaunchDarklyUserKeys {
  WilsonPortal = 'wilson-portal',
  WilsonMobile = 'wilson-mobile',
}
